import React from "react";
import PropTypes from "prop-types";
import { words } from "@alduino/humanizer/number";
import ProgrammeStates from "../../../enums/programmeStates";
import CurrentStepCardWrapper from "./CurrentStepCardWrapper";
import CompletedProgrammeCard from "../CompletedProgrammeCard/CompletedProgrammeCard";
import CompletedAvailableCard from "../CompletedAvailableCard";
import { UserProgrammeOverview } from "../../../types/UserProgrammeOverview";

import "./CurrentStepCard.scss";

const CardWrapper = ({ step, programme }) => {
  const subtitle =
    step?.stepNumber > 0
      ? `${step?.stepTitle} - Part ${words(step?.partNumber)}`
      : "Intro Video";

  return (
    <CurrentStepCardWrapper
      step={step}
      programme={programme}
      cardSubtitle={subtitle}
      cardTitle={step?.partTitle}
      description={step?.partWhatIsCovered ?? ""}
      imgUrl={
        step?.video?.thumbnail?.file?.url ??
        `https://image.mux.com/${step?.video?.videoDetails?.playbackId}/thumbnail.jpg?width=450&time=9`
      }
      imgTitle={step?.video?.videoDetails?.title}
    />
  );
};

CardWrapper.propTypes = {
  step: PropTypes.object.isRequired,
  programme: PropTypes.object,
};

interface Props {
  programmeOverview: UserProgrammeOverview | undefined;
}

const CurrentStepCard: React.FC<Props> = ({ programmeOverview }: Props) => {
  return (
    <>
      {programmeOverview?.state === ProgrammeStates.COMPLETE ? (
        <CompletedProgrammeCard programmeOverview={programmeOverview} />
      ) : programmeOverview?.state === ProgrammeStates.WAITING_UNLOCK ? (
        <CompletedAvailableCard programmeOverview={programmeOverview} />
      ) : programmeOverview?.state === ProgrammeStates.CONTENT_AVAILABLE &&
        programmeOverview?.nextAction !== null &&
        programmeOverview?.programme !== null ? (
        <CardWrapper
          step={programmeOverview.nextAction}
          programme={programmeOverview.programme}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default CurrentStepCard;
